import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";

import { Box } from "@mui/system";
import { Grid, Card } from "@mui/material";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { distributorContext } from "../context/contexts";
import DistributorDrawer from "../components/DistributorComponent/DistributorDrawer";
import { boxStyle, searchStyle, headerStyle } from "../style/style";

import OrgList from "../components/DistributorComponent/OrgList";
import OrgDetail from "../components/DistributorComponent/OrgDetail";
import DistributorSetting from "../components/DistributorComponent/DistributorSetting";

export default function DistributorPage() {
  const [distributor, setdistributor] = useState();
  const [refresh, setrefresh] = useState(false);
  const [id, setid] = useState("");
  const [detail, setdetail] = useState(false);
  const [page, setpage] = useState({
    Organizations: true,
    Settings: false,
  });
  const [search, setsearch] = useState(
    page.Organizations && detail && sessionStorage.getItem("search_devices")
      ? sessionStorage.getItem("search_devices")
      : "",
  );

  const [clicked, setclicked] = useState(
    page.Organizations && detail && sessionStorage.getItem("search_devices")
      ? true
      : false,
  );

  const history = useNavigate();

  const refact = (data) => {
    let res = {
      customer_id: {
        id: "",
        first_name: "",
        last_name: "",
        emial: "",
        phone_number: "",
      },
      logo: "",
      company_name: "",
      company_address: "",
      city: "",
      state: "",
      zip_code: "",
    };
    res["customer_id"]["id"] = data?.customer_id ?? "";
    res["customer_id"]["first_name"] = data.customer_first_name ?? "";
    res["customer_id"]["last_name"] = data.customer_last_name ?? "";
    res["customer_id"]["phone_number"] = data.customer_phone_number ?? "";
    res["customer_id"]["email"] = data.customer_email;
    res.logo = data.logo ?? "";
    res.company_name = data.company_name ?? "";
    res.company_address = data.company_address ?? "";
    res.city = data.city ?? "";
    res.state = data.state ?? "";
    res.zip_code = data.zip_code ?? "";

    //console.log(res);
    return res;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sessionStorage.setItem("search_devices", search);
    setclicked(true);
    setrefresh(!refresh);
  };

  useEffect(() => {
    if (
      sessionStorage.getItem("token") === "" ||
      !sessionStorage.getItem("token")
    ) {
      alert("Please log in to view this page!");
      history({ pathname: "/" });
    }
  }, [history]);

  return (
    <div>
      {localStorage.getItem("role") === "DISTRIBUTOR" ? (
        <distributorContext.Provider
          value={{
            page: page,
            setpage: setpage,
          }}
        >
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <DistributorDrawer
                  setsearch={setsearch}
                  setdistributor={setdistributor}
                  refresh={refresh}
                  setrefresh={setrefresh}
                />
              </Grid>
              <Grid item xs={10}>
                <Card sx={boxStyle}>
                  <Card sx={headerStyle}>
                    {page.Organizations
                      ? detail
                        ? id.company_name
                        : "Organizations"
                      : "Setting"}
                    <form style={searchStyle} onSubmit={handleSubmit}>
                      <FormControl variant="standard" sx={searchStyle}>
                        <InputLabel htmlFor="input-with-icon-adornment">
                          Search ...
                        </InputLabel>
                        <Input
                          id="input-with-icon-adornment"
                          startAdornment={
                            <InputAdornment position="start">
                              <SearchSharpIcon color="primary" />
                            </InputAdornment>
                          }
                          value={search}
                          onChange={(e) => {
                            setsearch(e.target.value);
                            if (e.target.value === "") {
                              setrefresh(!refresh);
                              sessionStorage.removeItem("search_devices");
                              setclicked(false);
                            }
                          }}
                        />
                      </FormControl>
                    </form>
                  </Card>
                </Card>
                {page.Organizations && (
                  <Card sx={boxStyle}>
                    {!detail ? (
                      <OrgList
                        id={sessionStorage.getItem("customer_id")}
                        setdetail={setdetail}
                        search={{
                          search: search,
                          setsearch: setsearch,
                        }}
                        refresh={refresh}
                        org_id={{ id: id, setid: setid }}
                        setrefresh={setrefresh}
                      />
                    ) : (
                      <OrgDetail
                        setdetail={setdetail}
                        id={id.customer_id["id"]}
                        search={search}
                        setsearch={setsearch}
                        clicked={clicked}
                        setclicked={setclicked}
                      />
                    )}
                  </Card>
                )}
                {page.Settings && (
                  <Card sx={boxStyle}>
                    {distributor && (
                      <DistributorSetting
                        distributor={refact(distributor)}
                        refresh={refresh}
                        setrefresh={setrefresh}
                        search={search}
                        setsearch={setsearch}
                      />
                    )}
                  </Card>
                )}
              </Grid>
            </Grid>
          </Box>
        </distributorContext.Provider>
      ) : (
        alert("You do not have permission to access this resource.")
      )}
    </div>
  );
}
